export default __webpack_public_path__ + "static/walk01-61ec9aed0e796a41d680348d140c4b24.png";